import $ from 'jquery';

class MenuManager {
  init({
      desktopMenuItemSelector = '.desktop-navigation--menu li',
      mobileMenuLinkSelector = '.js-mobile-navigation-menu-link',
      mobileNavigationSelector = '.o-mobile-navigation'
    } = {}) {
    const $desktopMenuItems = $(desktopMenuItemSelector);
    const $mobileMenuLinks = $(mobileMenuLinkSelector);
    const $mobileNavigation = $(mobileNavigationSelector);

    const setMenuItemOpen = function($menuItem, isOpen) {
      $menuItem.toggleClass('is-open', isOpen);
      $menuItem.children('a[aria-haspopup="true"]').attr('aria-expanded', String(isOpen));
    }

    const closeMobileMenu = function() {
      $mobileMenuLinks.closest('li.is-open').each(function() {
        setMenuItemOpen($(this), false);
      });
      $mobileNavigation.addClass('is-closing');
      setTimeout(function (){
        $mobileNavigation.removeClass('is-active is-closing');
        // $mobileNavigation.removeClass('is-closing');
      }, 250);

      $($mobileNavigation).off('click', outsideMobileMenuClickManager);
    }

    const outsideMobileMenuClickManager = function(e) {
      if(!$mobileNavigation.hasClass('is-active')) return;
      if($(e.target).hasClass('js-mobile-navigation')) {
        closeMobileMenu();
      }
    }

    $desktopMenuItems.on('mouseenter focusin', function() {
      setMenuItemOpen($(this), true);
    });

    $desktopMenuItems.on('mouseleave', function() {
      setMenuItemOpen($(this), false);
    });

    $desktopMenuItems.on('focusout', function(e) {
      const $menuItem = $(this);
      if (!$.contains($menuItem[0], e.relatedTarget)) {
        setMenuItemOpen($menuItem, false);
      }
    });

    $mobileMenuLinks.filter('.has-children').on('click', function(e) {
      e.preventDefault();

      const $menuItem = $(this).parent();
      const isOpen = !$menuItem.hasClass('is-open');
      setMenuItemOpen($menuItem, isOpen);

      if (!isOpen) {
        $menuItem.find('li.is-open').each(function() {
          setMenuItemOpen($(this), false);
        });
      }
    });

    $('#mobile-nav-close-button').on('click', function (e) {
      closeMobileMenu();
    });


    // Mobile nav
    $('.js-mobile-navigation--open').on('click', function(){
      $('.js-mobile-navigation').addClass('is-active');

      $($mobileNavigation).on('click', outsideMobileMenuClickManager);
    });
  }
}

export default MenuManager;
